<div class="modal-overlay" *ngIf="visible" (click)="onClose()">
  <div class="modal-container" (click)="$event.stopPropagation()">
    <!-- Modal Header -->
    <div class="modal-header">
      <div class="header-content">
        <h2 class="modal-title">Campaign Details</h2>
        <button class="close-btn" (click)="onClose()">
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13 1L1 13M1 1L13 13"
              stroke="#555963"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
      </div>

      <!-- Campaign Info Header -->
      <div class="campaign-header" *ngIf="campaign && !loading">
        <div class="campaign-info">
          <h3 class="campaign-name">{{ campaign.name }}</h3>
          <span [ngClass]="getStatusClass(campaign.campaign_status)" class="status-chip">
            {{ getStatusDisplay(campaign.campaign_status) }}
          </span>
        </div>
        <button class="action-btn menu-btn" (click)="showActionMenu($event)">
          <svg
            width="16"
            height="17"
            viewBox="0 0 16 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.33203 8.50008C7.33203 8.67689 7.40227 8.84646 7.52729 8.97149C7.65232 9.09651 7.82189 9.16675 7.9987 9.16675C8.17551 9.16675 8.34508 9.09651 8.4701 8.97149C8.59513 8.84646 8.66536 8.67689 8.66536 8.50008C8.66536 8.32327 8.59513 8.1537 8.4701 8.02868C8.34508 7.90365 8.17551 7.83341 7.9987 7.83341C7.82189 7.83341 7.65232 7.90365 7.52729 8.02868C7.40227 8.1537 7.33203 8.32327 7.33203 8.50008Z"
              stroke="#15172E"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M7.33203 13.1667C7.33203 13.3436 7.40227 13.5131 7.52729 13.6382C7.65232 13.7632 7.82189 13.8334 7.9987 13.8334C8.17551 13.8334 8.34508 13.7632 8.4701 13.6382C8.59513 13.5131 8.66536 13.3436 8.66536 13.1667C8.66536 12.9899 8.59513 12.8204 8.4701 12.6953C8.34508 12.5703 8.17551 12.5001 7.9987 12.5001C7.82189 12.5001 7.65232 12.5703 7.52729 12.6953C7.40227 12.8204 7.33203 12.9899 7.33203 13.1667Z"
              stroke="#15172E"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M7.33203 3.83341C7.33203 4.01023 7.40227 4.17979 7.52729 4.30482C7.65232 4.42984 7.82189 4.50008 7.9987 4.50008C8.17551 4.50008 8.34508 4.42984 8.4701 4.30482C8.59513 4.17979 8.66536 4.01023 8.66536 3.83341C8.66536 3.6566 8.59513 3.48703 8.4701 3.36201C8.34508 3.23699 8.17551 3.16675 7.9987 3.16675C7.82189 3.16675 7.65232 3.23699 7.52729 3.36201C7.40227 3.48703 7.33203 3.6566 7.33203 3.83341Z"
              stroke="#15172E"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
      </div>

      <!-- Loading State -->
      <div class="campaign-header" *ngIf="loading">
        <div class="campaign-info">
          <div class="loading-skeleton">
            <div class="skeleton-line skeleton-title"></div>
            <div class="skeleton-line skeleton-status"></div>
          </div>
        </div>
      </div>

      <!-- Error State -->
      <div class="campaign-header" *ngIf="error && !loading">
        <div class="campaign-info">
          <div class="error-message">
            <p>{{ error }}</p>
            <button class="retry-btn" (click)="loadCampaign()">Retry</button>
          </div>
        </div>
      </div>

      <!-- Tab Navigation -->
      <div class="tab-navigation">
        <div class="tab-list">
          <button
            *ngFor="let tab of tabs; trackBy: trackByIndex"
            class="tab-item"
            [class.active]="tab.active"
            (click)="setActiveTab(tab.id)"
          >
            <svg
              *ngIf="tab.icon === 'clipboard-list'"
              width="10"
              height="13"
              viewBox="0 0 10 13"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3.2513 2.41667H2.08464C1.77522 2.41667 1.47847 2.53958 1.25968 2.75838C1.04089 2.97717 0.917969 3.27391 0.917969 3.58333V10.5833C0.917969 10.8928 1.04089 11.1895 1.25968 11.4083C1.47847 11.6271 1.77522 11.75 2.08464 11.75H7.91797C8.22739 11.75 8.52413 11.6271 8.74293 11.4083C8.96172 11.1895 9.08464 10.8928 9.08464 10.5833V3.58333C9.08464 3.27391 8.96172 2.97717 8.74293 2.75838C8.52413 2.53958 8.22739 2.41667 7.91797 2.41667H6.7513M3.2513 2.41667C3.2513 2.10725 3.37422 1.8105 3.59301 1.59171C3.8118 1.37292 4.10855 1.25 4.41797 1.25H5.58464C5.89405 1.25 6.1908 1.37292 6.40959 1.59171C6.62839 1.8105 6.7513 2.10725 6.7513 2.41667M3.2513 2.41667C3.2513 2.72609 3.37422 3.02283 3.59301 3.24162C3.8118 3.46042 4.10855 3.58333 4.41797 3.58333H5.58464C5.89405 3.58333 6.1908 3.46042 6.40959 3.24162C6.62839 3.02283 6.7513 2.72609 6.7513 2.41667M3.2513 6.5H3.25714M5.58464 6.5H6.7513M3.2513 8.83333H3.25714M5.58464 8.83333H6.7513"
                stroke="#15172E"
                stroke-width="1.25"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>

            <svg
              *ngIf="tab.icon === 'tag'"
              width="12"
              height="12"
              viewBox="0 0 12 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3.95703 4.04183C4.2792 4.04183 4.54036 3.78066 4.54036 3.4585C4.54036 3.13633 4.2792 2.87516 3.95703 2.87516C3.63487 2.87516 3.3737 3.13633 3.3737 3.4585C3.3737 3.78066 3.63487 4.04183 3.95703 4.04183Z"
                fill="#15172E"
              />
              <path
                d="M3.95703 4.04183C4.2792 4.04183 4.54036 3.78066 4.54036 3.4585C4.54036 3.13633 4.2792 2.87516 3.95703 2.87516C3.63487 2.87516 3.3737 3.13633 3.3737 3.4585C3.3737 3.78066 3.63487 4.04183 3.95703 4.04183Z"
                stroke="#15172E"
                stroke-width="1.25"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M1.33203 2.5835V4.83458C1.33203 5.14783 1.45628 5.44825 1.67795 5.66991L6.41228 10.4042C6.52197 10.514 6.6522 10.601 6.79553 10.6604C6.93886 10.7197 7.09248 10.7503 7.24761 10.7503C7.40275 10.7503 7.55637 10.7197 7.6997 10.6604C7.84303 10.601 7.97326 10.514 8.08295 10.4042L10.9028 7.58441C11.0125 7.47472 11.0995 7.34449 11.1589 7.20117C11.2183 7.05784 11.2488 6.90422 11.2488 6.74908C11.2488 6.59394 11.2183 6.44032 11.1589 6.29699C11.0995 6.15367 11.0125 6.02344 10.9028 5.91375L6.16786 1.17941C5.94645 0.958036 5.64621 0.833617 5.33311 0.833496H3.08203C2.6179 0.833496 2.17278 1.01787 1.84459 1.34606C1.51641 1.67425 1.33203 2.11937 1.33203 2.5835Z"
                stroke="#15172E"
                stroke-width="1.25"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>

            <svg
              *ngIf="tab.icon === 'pencil'"
              width="11"
              height="11"
              viewBox="0 0 11 11"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6.8737 2.29168L9.20703 4.62502M1.33203 10.1667H3.66536L9.79037 4.04168C10.0998 3.73226 10.2736 3.3126 10.2736 2.87501C10.2736 2.43743 10.0998 2.01777 9.79037 1.70835C9.48095 1.39893 9.06128 1.2251 8.6237 1.2251C8.18611 1.2251 7.76645 1.39893 7.45703 1.70835L1.33203 7.83335V10.1667Z"
                stroke="#15172E"
                stroke-width="1.25"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>

            <svg
              *ngIf="tab.icon === 'target'"
              width="12"
              height="13"
              viewBox="0 0 12 13"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5.41667 6.5C5.41667 6.65471 5.47812 6.80308 5.58752 6.91248C5.69692 7.02187 5.84529 7.08333 6 7.08333C6.15471 7.08333 6.30308 7.02187 6.41248 6.91248C6.52187 6.80308 6.58333 6.65471 6.58333 6.5C6.58333 6.34529 6.52187 6.19692 6.41248 6.08752C6.30308 5.97812 6.15471 5.91667 6 5.91667C5.84529 5.91667 5.69692 5.97812 5.58752 6.08752C5.47812 6.19692 5.41667 6.34529 5.41667 6.5Z"
                stroke="#15172E"
                stroke-width="1.25"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M3.08333 6.5C3.08333 7.27355 3.39062 8.01541 3.93761 8.56239C4.48459 9.10938 5.22645 9.41667 6 9.41667C6.77355 9.41667 7.51541 9.10938 8.06239 8.56239C8.60938 8.01541 8.91667 7.27355 8.91667 6.5C8.91667 5.72645 8.60938 4.98459 8.06239 4.43761C7.51541 3.89062 6.77355 3.58333 6 3.58333C5.22645 3.58333 4.48459 3.89062 3.93761 4.43761C3.39062 4.98459 3.08333 5.72645 3.08333 6.5Z"
                stroke="#15172E"
                stroke-width="1.25"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M0.75 6.5C0.75 7.18944 0.885795 7.87213 1.14963 8.50909C1.41347 9.14605 1.80018 9.7248 2.28769 10.2123C2.7752 10.6998 3.35395 11.0865 3.99091 11.3504C4.62787 11.6142 5.31056 11.75 6 11.75C6.68944 11.75 7.37213 11.6142 8.00909 11.3504C8.64605 11.0865 9.2248 10.6998 9.71231 10.2123C10.1998 9.7248 10.5865 9.14605 10.8504 8.50909C11.1142 7.87213 11.25 7.18944 11.25 6.5C11.25 5.81056 11.1142 5.12787 10.8504 4.49091C10.5865 3.85395 10.1998 3.2752 9.71231 2.78769C9.2248 2.30018 8.64605 1.91347 8.00909 1.64963C7.37213 1.3858 6.68944 1.25 6 1.25C5.31056 1.25 4.62787 1.3858 3.99091 1.64963C3.35395 1.91347 2.7752 2.30018 2.28769 2.78769C1.80018 3.2752 1.41347 3.85395 1.14963 4.49091C0.885795 5.12787 0.75 5.81056 0.75 6.5Z"
                stroke="#15172E"
                stroke-width="1.25"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>

            <svg
              *ngIf="tab.icon === 'users'"
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M4.66667 12.25V11.6667C4.66667 11.3572 4.78958 11.0605 5.00838 10.8417C5.22717 10.6229 5.52391 10.5 5.83333 10.5H8.16667C8.47609 10.5 8.77283 10.6229 8.99162 10.8417C9.21042 11.0605 9.33333 11.3572 9.33333 11.6667V12.25M9.91667 5.83333H11.0833C11.3928 5.83333 11.6895 5.95625 11.9083 6.17504C12.1271 6.39383 12.25 6.69058 12.25 7V7.58333M1.75 7.58333V7C1.75 6.69058 1.87292 6.39383 2.09171 6.17504C2.3105 5.95625 2.60725 5.83333 2.91667 5.83333H4.08333M5.83333 7.58333C5.83333 7.89275 5.95625 8.1895 6.17504 8.40829C6.39383 8.62708 6.69058 8.75 7 8.75C7.30942 8.75 7.60617 8.62708 7.82496 8.40829C8.04375 8.1895 8.16667 7.89275 8.16667 7.58333C8.16667 7.27391 8.04375 6.97717 7.82496 6.75838C7.60617 6.53958 7.30942 6.41667 7 6.41667C6.69058 6.41667 6.39383 6.53958 6.17504 6.75838C5.95625 6.97717 5.83333 7.27391 5.83333 7.58333ZM8.75 2.91667C8.75 3.22609 8.87292 3.52283 9.09171 3.74162C9.3105 3.96042 9.60725 4.08333 9.91667 4.08333C10.2261 4.08333 10.5228 3.96042 10.7416 3.74162C10.9604 3.52283 11.0833 3.22609 11.0833 2.91667C11.0833 2.60725 10.9604 2.3105 10.7416 2.09171C10.5228 1.87292 10.2261 1.75 9.91667 1.75C9.60725 1.75 9.3105 1.87292 9.09171 2.09171C8.87292 2.3105 8.75 2.60725 8.75 2.91667ZM2.91667 2.91667C2.91667 3.22609 3.03958 3.52283 3.25838 3.74162C3.47717 3.96042 3.77391 4.08333 4.08333 4.08333C4.39275 4.08333 4.6895 3.96042 4.90829 3.74162C5.12708 3.52283 5.25 3.22609 5.25 2.91667C5.25 2.60725 5.12708 2.3105 4.90829 2.09171C4.6895 1.87292 4.39275 1.75 4.08333 1.75C3.77391 1.75 3.47717 1.87292 3.25838 2.09171C3.03958 2.3105 2.91667 2.60725 2.91667 2.91667Z"
                stroke="#15172E"
                stroke-width="1.25"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>

            <svg
              *ngIf="tab.icon === 'settings'"
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6.02292 11.4818C5.98574 11.3278 5.91271 11.1848 5.80978 11.0644C5.70685 10.9441 5.57693 10.8497 5.43061 10.7891C5.28429 10.7285 5.12572 10.7033 4.96782 10.7156C4.80992 10.7279 4.65716 10.7774 4.522 10.8599C3.62192 11.4083 2.59117 10.3781 3.1395 9.47742C3.22181 9.34228 3.27107 9.18964 3.28328 9.03188C3.29549 8.87413 3.27031 8.71572 3.20978 8.56953C3.14924 8.42334 3.05507 8.2935 2.93491 8.19055C2.81475 8.08761 2.672 8.01447 2.51825 7.97708C1.49392 7.72858 1.49392 6.27142 2.51825 6.02292C2.67213 5.98563 2.81504 5.91254 2.93533 5.80959C3.05563 5.70663 3.14991 5.57673 3.21052 5.43045C3.27112 5.28417 3.29633 5.12565 3.28409 4.96779C3.27185 4.80993 3.22251 4.65719 3.14008 4.522C2.59175 3.62192 3.62192 2.59117 4.52258 3.1395C5.10592 3.49417 5.86192 3.18033 6.02292 2.51825C6.27142 1.49392 7.72858 1.49392 7.97708 2.51825C8.01437 2.67213 8.08746 2.81504 8.19041 2.93533C8.29337 3.05563 8.42327 3.14992 8.56955 3.21052C8.71583 3.27112 8.87435 3.29633 9.03221 3.28409C9.19007 3.27185 9.34281 3.22251 9.478 3.14008C10.3781 2.59175 11.4088 3.62192 10.8605 4.52258C10.7782 4.65772 10.7289 4.81036 10.7167 4.96812C10.7045 5.12587 10.7297 5.28428 10.7902 5.43047C10.8508 5.57666 10.9449 5.7065 11.0651 5.80945C11.1852 5.91239 11.328 5.98553 11.4817 6.02292C11.6177 6.05293 11.7456 6.11173 11.8569 6.19535C11.9682 6.27896 12.0603 6.38546 12.1269 6.50767M8.68582 6.5304C8.6094 6.2555 8.46695 6.00345 8.27086 5.79618C8.07477 5.58892 7.83099 5.43272 7.56075 5.34119C7.2905 5.24967 7.00198 5.22559 6.7203 5.27104C6.43862 5.3165 6.17232 5.43012 5.94459 5.602C5.71685 5.77389 5.53458 5.99884 5.41364 6.25727C5.29271 6.51569 5.23677 6.79976 5.2507 7.08474C5.26463 7.36973 5.34801 7.64699 5.49358 7.89238C5.63914 8.13778 5.84249 8.34388 6.0859 8.49273M10.3833 12.1432L9.11633 12.8071C9.07873 12.8266 9.03643 12.8354 8.99416 12.8323C8.95188 12.8292 8.91129 12.8144 8.87692 12.7896C8.84256 12.7648 8.81576 12.731 8.79953 12.6918C8.78329 12.6526 8.77826 12.6098 8.785 12.5679L9.02708 11.1615L8.00216 10.1657C7.97157 10.1362 7.94991 10.0986 7.93965 10.0573C7.9294 10.016 7.93096 9.97265 7.94416 9.9322C7.95736 9.89175 7.98166 9.85582 8.0143 9.82853C8.04694 9.80123 8.0866 9.78366 8.12875 9.77782L9.54508 9.57249L10.1786 8.29324C10.1975 8.25513 10.2267 8.22308 10.2629 8.20067C10.2991 8.17826 10.3408 8.16638 10.3833 8.16638C10.4259 8.16638 10.4676 8.17826 10.5038 8.20067C10.5399 8.22308 10.5691 8.25513 10.5881 8.29324L11.2216 9.57249L12.6379 9.77782C12.6799 9.78386 12.7194 9.80155 12.7519 9.82887C12.7844 9.85619 12.8086 9.89207 12.8218 9.93243C12.835 9.97279 12.8366 10.016 12.8265 10.0573C12.8163 10.0985 12.7949 10.1361 12.7645 10.1657L11.7396 11.1615L11.9811 12.5673C11.9883 12.6092 11.9837 12.6524 11.9677 12.6918C11.9516 12.7312 11.9249 12.7653 11.8904 12.7903C11.856 12.8152 11.8152 12.8301 11.7728 12.833C11.7303 12.836 11.6879 12.827 11.6503 12.8071L10.3833 12.1432Z"
                stroke="#15172E"
                stroke-width="1.25"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>

            <svg
              *ngIf="tab.icon === 'calendar'"
              width="12"
              height="13"
              viewBox="0 0 12 13"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8.33398 1.25V3.58333M3.66732 1.25V3.58333M1.33398 5.91667H10.6673M5.41732 8.25H6.00065V10M1.33398 3.58333C1.33398 3.27391 1.4569 2.97717 1.67569 2.75838C1.89449 2.53958 2.19123 2.41667 2.50065 2.41667H9.50065C9.81007 2.41667 10.1068 2.53958 10.3256 2.75838C10.5444 2.97717 10.6673 3.27391 10.6673 3.58333V10.5833C10.6673 10.8928 10.5444 11.1895 10.3256 11.4083C10.1068 11.6271 9.81007 11.75 9.50065 11.75H2.50065C2.19123 11.75 1.89449 11.6271 1.67569 11.4083C1.4569 11.1895 1.33398 10.8928 1.33398 10.5833V3.58333Z"
                stroke="#15172E"
                stroke-width="1.25"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>

            <span class="tab-label">{{ tab.label }}</span>
          </button>
        </div>
      </div>
    </div>

    <!-- Modal Content -->
    <div class="modal-content">
      <!-- Loading State -->
      <div *ngIf="loading" class="tab-content loading-content">
        <div class="loading-spinner">
          <div class="spinner"></div>
          <p>Loading campaign data...</p>
        </div>
      </div>

      <!-- Error State -->
      <div *ngIf="error && !loading" class="tab-content error-content">
        <div class="error-message">
          <p>{{ error }}</p>
          <button class="retry-btn" (click)="loadCampaign()">Retry</button>
        </div>
      </div>

      <!-- Overview Tab Content -->
      <div *ngIf="activeTab === 'overview' && campaign && !loading" class="tab-content">
        <app-campaign-overview [campaign]="campaign"></app-campaign-overview>
      </div>

      <!-- Leads Tab Content -->
      <div *ngIf="activeTab === 'leads' && campaign && !loading" class="tab-content">
        <app-campaign-leads [campaign]="campaign"></app-campaign-leads>
      </div>

      <!-- Advance Tab Content -->
      <div
        *ngIf="activeTab === 'advance' && campaign && !loading"
        class="tab-content advance-tab-content"
      >
        <div class="advance-empty-state" *ngIf="!hasAdvanceContent()">
          <div class="advance-empty-state-card">
            <h3 class="advance-empty-state-title">No Content Available</h3>
            <p class="advance-empty-state-description">
              You haven't created any campaign content yet. Start by selecting advance, then create
              landing page, success page, and SMS/email.
            </p>
            <button type="button" class="advance-edit-btn" (click)="onEditAdvance()">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9.2487 3.41668L11.582 5.75002M2.33203 12.6667H4.66536L11.4154 5.91668C11.6342 5.69781 11.8079 5.43797 11.9263 5.152C12.0448 4.86604 12.1057 4.55954 12.1057 4.25002C12.1057 3.94049 12.0448 3.63399 11.9263 3.34802C11.8079 3.06206 11.6342 2.80222 11.4154 2.58335C11.1965 2.36448 10.9367 2.19087 10.6507 2.07242C10.3647 1.95396 10.0582 1.89301 9.7487 1.89301C9.43917 1.89301 9.13267 1.95396 8.8467 2.07242C8.56074 2.19087 8.3009 2.36448 8.08203 2.58335L2.33203 8.33335V10.6667Z"
                  stroke="currentColor"
                  stroke-width="1.25"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              Edit Advance
            </button>
          </div>
        </div>

        <div class="advance-configured-state" *ngIf="hasAdvanceContent()">
          <div class="advance-configured-card">
            <h3 class="advance-configured-title">No Content Available</h3>
            <p class="advance-configured-description">
              You haven't created any campaign content yet. Start by selecting advance, then create
              landing page, success page, and SMS/email .
            </p>
            <button type="button" class="advance-edit-btn" (click)="onEditAdvance()">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9.2487 3.41668L11.582 5.75002M2.33203 12.6667H4.66536L11.4154 5.91668C11.6342 5.69781 11.8079 5.43797 11.9263 5.152C12.0448 4.86604 12.1057 4.55954 12.1057 4.25002C12.1057 3.94049 12.0448 3.63399 11.9263 3.34802C11.8079 3.06206 11.6342 2.80222 11.4154 2.58335C11.1965 2.36448 10.9367 2.19087 10.6507 2.07242C10.3647 1.95396 10.0582 1.89301 9.7487 1.89301C9.43917 1.89301 9.13267 1.95396 8.8467 2.07242C8.56074 2.19087 8.3009 2.36448 8.08203 2.58335L2.33203 8.33335V10.6667Z"
                  stroke="currentColor"
                  stroke-width="1.25"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              Edit Advance
            </button>
          </div>
        </div>
      </div>

      <!-- Offers Tab Content -->
      <div *ngIf="activeTab === 'offers' && campaign && !loading" class="tab-content">
        <app-campaign-offers [campaign]="campaign"></app-campaign-offers>
      </div>

      <!-- Content Tab Content -->
      <div *ngIf="activeTab === 'content' && campaign && !loading" class="tab-content">
        <app-campaign-content [campaign]="campaign"></app-campaign-content>
      </div>

      <!-- Goals Tab Content -->
      <div *ngIf="activeTab === 'goals' && campaign && !loading" class="tab-content">
        <app-campaign-goals [campaign]="campaign"></app-campaign-goals>
      </div>

      <!-- Schedule Tab Content -->
      <div *ngIf="activeTab === 'schedule' && campaign && !loading" class="tab-content">
        <app-campaign-schedule [campaign]="campaign"></app-campaign-schedule>
      </div>
    </div>
  </div>
</div>

<!-- Campaign Action Menu -->
<p-popover #actionMenuPanel [style]="{ width: '155px' }" styleClass="action-menu-panel">
  <ng-template pTemplate>
    <div class="action-menu-content">
      <div class="action-menu-item" (click)="onEdit(); actionMenuPanel.hide()">
        <span>Edit</span>
        <svg
          width="11"
          height="11"
          viewBox="0 0 11 11"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.8737 1.79168L9.20703 4.12502M1.33203 9.66668H3.66536L9.79037 3.54168C10.0998 3.23226 10.2736 2.8126 10.2736 2.37501C10.2736 1.93743 10.0998 1.51777 9.79037 1.20835C9.48095 0.898928 9.06128 0.725098 8.6237 0.725098C8.18611 0.725098 7.76645 0.898928 7.45703 1.20835L1.33203 7.33335V9.66668Z"
            stroke="#555963"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
      <div
        *ngIf="campaign?.campaign_status !== 'archived'"
        class="action-menu-item"
        (click)="onDuplicateCampaign(); actionMenuPanel.hide()"
      >
        <span>Duplicate</span>
        <svg
          width="12"
          height="12"
          viewBox="0 0 12 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8.33203 3.66659V2.49992C8.33203 2.1905 8.20912 1.89375 7.99032 1.67496C7.77153 1.45617 7.47478 1.33325 7.16536 1.33325H2.4987C2.18928 1.33325 1.89253 1.45617 1.67374 1.67496C1.45495 1.89375 1.33203 2.1905 1.33203 2.49992V7.16659C1.33203 7.476 1.45495 7.77275 1.67374 7.99154C1.89253 8.21034 2.18928 8.33325 2.4987 8.33325H3.66536M3.66536 4.83325C3.66536 4.52383 3.78828 4.22709 4.00707 4.00829C4.22587 3.7895 4.52261 3.66659 4.83203 3.66659H9.4987C9.80812 3.66659 10.1049 3.7895 10.3237 4.00829C10.5424 4.22709 10.6654 4.52383 10.6654 4.83325V9.49992C10.6654 9.80934 10.5424 10.1061 10.3237 10.3249C10.1049 10.5437 9.80812 10.6666 9.4987 10.6666H4.83203C4.52261 10.6666 4.22587 10.5437 4.00707 10.3249C3.78828 10.1061 3.66536 9.80934 3.66536 9.49992V4.83325Z"
            stroke="#555963"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
      <div
        class="action-menu-item"
        *ngIf="
          campaign?.campaign_status !== 'stopped' &&
          campaign?.campaign_status !== 'archived' &&
          campaign?.campaign_status !== 'completed' &&
          campaign?.campaign_status !== 'draft'
        "
        (click)="onPauseCampaign(); actionMenuPanel.hide()"
      >
        <span>{{ campaign?.campaign_status === 'paused' ? 'Resume' : 'Pause' }}</span>
        <!-- Pause Icon (when campaign is active or resumed) -->
        <svg
          *ngIf="campaign?.campaign_status !== 'paused'"
          width="10"
          height="11"
          viewBox="0 0 10 11"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1 1.50004C1 1.32323 1.07024 1.15366 1.19526 1.02864C1.32029 0.903612 1.48986 0.833374 1.66667 0.833374H3C3.17681 0.833374 3.34638 0.903612 3.4714 1.02864C3.59643 1.15366 3.66667 1.32323 3.66667 1.50004V9.50004C3.66667 9.67685 3.59643 9.84642 3.4714 9.97145C3.34638 10.0965 3.17681 10.1667 3 10.1667H1.66667C1.48986 10.1667 1.32029 10.0965 1.19526 9.97145C1.07024 9.84642 1 9.67685 1 9.50004V1.50004Z"
            stroke="#555963"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M6.33333 1.50004C6.33333 1.32323 6.40357 1.15366 6.5286 1.02864C6.65362 0.903612 6.82319 0.833374 7 0.833374H8.33333C8.51014 0.833374 8.67971 0.903612 8.80474 1.02864C8.92976 1.15366 9 1.32323 9 1.50004V9.50004C9 9.67685 8.92976 9.84642 8.80474 9.97145C8.67971 10.0965 8.51014 10.1667 8.33333 10.1667H7C6.82319 10.1667 6.65362 10.0965 6.5286 9.97145C6.40357 9.84642 6.33333 9.67685 6.33333 9.50004V1.50004Z"
            stroke="#555963"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <!-- Play Icon (when campaign is paused) -->
        <svg
          *ngIf="campaign?.campaign_status === 'paused'"
          width="12"
          height="13"
          viewBox="0 0 12 13"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.66797 1.16675V11.8334L10.3346 6.50008L1.66797 1.16675Z"
            fill="#F1F2F9"
            stroke="#555963"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
      <div
        class="action-menu-item"
        *ngIf="
          campaign?.campaign_status !== 'stopped' &&
          campaign?.campaign_status !== 'archived' &&
          campaign?.campaign_status !== 'completed' &&
          campaign?.campaign_status !== 'draft'
        "
        (click)="onStopCampaign(); actionMenuPanel.hide()"
      >
        <span>Stop</span>
        <svg
          width="12"
          height="11"
          viewBox="0 0 12 11"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.33203 2.16671C1.33203 1.81309 1.47251 1.47395 1.72256 1.2239C1.9726 0.97385 2.31174 0.833374 2.66536 0.833374H9.33203C9.68565 0.833374 10.0248 0.97385 10.2748 1.2239C10.5249 1.47395 10.6654 1.81309 10.6654 2.16671V8.83337C10.6654 9.187 10.5249 9.52613 10.2748 9.77618C10.0248 10.0262 9.68565 10.1667 9.33203 10.1667H2.66536C2.31174 10.1667 1.9726 10.0262 1.72256 9.77618C1.47251 9.52613 1.33203 9.187 1.33203 8.83337V2.16671Z"
            stroke="#555963"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
      <!-- <div class="action-menu-item" 
                 *ngIf="campaign?.campaign_status !== 'draft' && campaign?.campaign_status !== 'scheduled'"
                 (click)="onMarkComplete(); actionMenuPanel.hide()">
                <span>Mark Complete</span>
                <svg width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 9.5V7.5M3.66667 9.5V5.5M6.33333 9.5V3.5M9 9.5V1.5" stroke="#555963" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div> -->
      <div
        class="action-menu-item archive-item"
        *ngIf="campaign?.campaign_status !== 'archived'"
        (click)="onArchiveCampaign(); actionMenuPanel.hide()"
      >
        <span>Archive</span>
        <svg
          width="12"
          height="12"
          viewBox="0 0 12 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.0833 3.66659C10.3928 3.66659 10.6895 3.54367 10.9083 3.32488C11.1271 3.10608 11.25 2.80934 11.25 2.49992C11.25 2.1905 11.1271 1.89375 10.9083 1.67496C10.6895 1.45617 10.3928 1.33325 10.0833 1.33325H1.91667C1.60725 1.33325 1.3105 1.45617 1.09171 1.67496C0.872916 1.89375 0.75 2.1905 0.75 2.49992C0.75 2.80934 0.872916 3.10608 1.09171 3.32488C1.3105 3.54367 1.60725 3.66659 1.91667 3.66659M10.0833 3.66659H1.91667M10.0833 3.66659V9.49992C10.0833 9.80934 9.96042 10.1061 9.74162 10.3249C9.52283 10.5437 9.22609 10.6666 8.91667 10.6666H3.08333C2.77391 10.6666 2.47717 10.5437 2.25838 10.3249C2.03958 10.1061 1.91667 9.80934 1.91667 9.49992V3.66659M4.83333 5.99992H7.16667"
            stroke="#DA1E28"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
    </div>
  </ng-template>
</p-popover>

<!-- Duplicate Campaign Modal -->
<app-duplicate-campaign-modal
  *ngIf="showDuplicateModal"
  [campaign]="campaign"
  (confirmDuplicate)="onConfirmDuplicate($event)"
  (close)="onCloseDuplicateModal()"
>
</app-duplicate-campaign-modal>

<!-- Pause Campaign Modal -->
<app-pause-campaign-modal
  *ngIf="showPauseModal"
  [campaign]="campaign"
  (confirmPause)="onConfirmPause($event)"
  (close)="onClosePauseModal()"
>
</app-pause-campaign-modal>

<!-- Stop Campaign Modal -->
<app-stop-campaign-modal
  *ngIf="showStopModal"
  [campaign]="campaign"
  (confirmStop)="onConfirmStop($event)"
  (close)="onCloseStopModal()"
>
</app-stop-campaign-modal>

<!-- Archive Campaign Modal -->
<app-archive-campaign-modal
  *ngIf="showArchiveModal"
  [campaign]="campaign"
  (confirmArchive)="onConfirmArchive($event)"
  (close)="onCloseArchiveModal()"
>
</app-archive-campaign-modal>
